module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-310x310.72d48ed67acc151ed5b19ef6c9a9332b.png";